export default "__VITE_ASSET__BhbodgUa__"